import styled from 'styled-components';
import { DEVICES } from '_constants';

export const AgencySelectionWrapper = styled.div`
  #agency-report {
    outline: none !important;
    border: none !important;
    box-shadow: none !important;
  }

  label {
    padding: 0;
  }

  .BaseSelect__control {
    width: 130px;
    @media ${DEVICES.laptop} {
      min-width: 120px;
    }
  }

  .BaseSelect__menu {
    font-size: 14px;
    width: 130px;
  }

  .BaseSelect__option {
    height: 24px;
    padding: 2px;
  }

  margin-bottom: 15px;
`;

export const ReportDescription = styled.div`
  padding: 10px;
  color: black;
`;

export const SectionWrapper = styled.div`
  margin-bottom: 15px;
`;

export const ReportActionWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 10px;

  @media ${DEVICES.tablet} {
    flex-direction: column;
    align-items: flex-start;
    .export_dropdown {
      margin: 10px;
    }
  }

  button {
    height: 38px;
  }

  .custom-react-date-picker {
    width: 150px;
  }

  .react-datepicker {
    width: auto;
    padding: 35px 25px 15px;
  }

  .react-datepicker__header__dropdown {
    top: -25px;
  }

  .react-datepicker__navigation--previous {
    right: 50px;
    top: 15px;
  }

  .react-datepicker__navigation--next {
    right: 35px;
    top: 15px;
  }

  .react-datepicker__month-container {
    width: 250px;
    height: 210px;
  }
`;
export const AccordionWrapper = styled.div`
  #county_ago_report {
    outline: none !important;
    border: none !important;
    box-shadow: none !important;
  }

  button {
    border-top: 1px solid #cccccc !important;
  }

  .BaseSelect__control {
    width: 120px;

    @media ${DEVICES.laptop} {
      min-width: 120px;
    }
  }

  .BaseSelect__menu {
    font-size: 14px;
    width: 120px;
    @media ${DEVICES.laptop} {
      min-width: 12px;
    }
  }

  .BaseSelect__option {
    height: 24px;
    padding: 2px;
  }
`;
export const CountyOptionsWrapper = styled.div`
  margin-left: 10px;
  margin-bottom: 5px;
`;
